import React from "react";
import { UI_ICONS, UiIconName } from "../utils/uiIcons";

// Rendu web des icônes de utils/uiIcons.ts — miroir de OLTODO/components/UiIcon.tsx.
export default function UiIcon({ name, size = 20, color = "currentColor", strokeWidth = 1.9, style }: { name: UiIconName; size?: number; color?: string; strokeWidth?: number; style?: React.CSSProperties }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, display: "block", ...style }} aria-hidden="true">
      {UI_ICONS[name].map((s, i) =>
        s[0] === "p" ? <path key={i} d={s[1]} /> :
        s[0] === "c" ? <circle key={i} cx={s[1]} cy={s[2]} r={s[3]} /> :
        s[0] === "r" ? <rect key={i} x={s[1]} y={s[2]} width={s[3]} height={s[4]} rx={s[5]} /> :
        <line key={i} x1={s[1]} y1={s[2]} x2={s[3]} y2={s[4]} />
      )}
    </svg>
  );
}
